import React, { ReactNode } from "react";
import styled from "styled-components";

interface LoggedInLayoutProps {
	children?: ReactNode;
}

const LoggedInLayout: React.FC<LoggedInLayoutProps> = ({ children }) => {
	return (
		<LoggedOutLayoutStyle>
			<img alt="origo-logo" src="/svg/origo-logo.svg" />
			{children}
		</LoggedOutLayoutStyle>
	);
};

export default LoggedInLayout;

const LoggedOutLayoutStyle = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	min-height: 100vh;
	width: 100vw;
	background-image: url("/svg/login-background.svg");
	background-color: ${(props) => props.theme.colors.COLOR_LIGHT_GRAY};
	background-repeat: no-repeat;
	background-size: cover;
	img {
		margin: 3rem;
	}
`;
